'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
exports.createConnectOrDisconnect = exports.updateOrDelete = exports.createUpdateOrDelete = exports.findDelete = exports.createOrUpdate = void 0;
function createOrUpdate(array = [], transform, pk = 'id') {
  return array.reduce((acc, i) => {
    const obj = transform ? transform(i) : i;
    if (!obj) return acc;
    const key = i[pk] ? 'update' : 'create';
    const value = acc;
    return Object.assign(Object.assign({}, acc), {
      [key]: [
        ...(value[key] || []),
        i[pk]
          ? {
            data: obj,
            where: { [pk]: i[pk] },
          }
          : obj,
      ],
    });
  }, {});
}
exports.createOrUpdate = createOrUpdate;
function findDelete(current, initial, pk = 'id') {
  return initial
    .filter(i => i[pk] && !current.find(item => item[pk] === i[pk]))
    .map(i => ({ [pk]: i[pk] }));
}
exports.findDelete = findDelete;
function createUpdateOrDelete(
  current = [],
  initial = [],
  transform,
  pk = 'id'
) {
  const toDelete = findDelete(current, initial, pk);
  return Object.assign(
    Object.assign({}, createOrUpdate(current, transform, pk)),
    { delete: toDelete }
  );
}
exports.createUpdateOrDelete = createUpdateOrDelete;
function updateOrDelete(
  current = [],
  initial = [],
  transform,
  pk = 'id'
) {
  const toDelete = findDelete(current, initial, pk);
  const toUpdate = current
    .map(i => {
      const iItem = initial.find(item => item[pk] === i[pk]);
      if (iItem && JSON.stringify(iItem) === JSON.stringify(i)) return null;
      const obj = transform ? transform(i) : i;
      return {
        data: obj,
        where: { [pk]: i[pk] },
      };
    })
    .filter(i => i !== null);
  return { delete: toDelete, update: toUpdate };
}
exports.updateOrDelete = updateOrDelete;
function mapToPrimary(items, pk) {
  return items.map(i => ({ [pk]: i[pk] }));
}
function createConnectOrDisconnect(
  current = [],
  initial = [],
  pk = 'id'
) {
  const toDelete = findDelete(current, initial, pk);
  const toCreate = current.filter(i => !i[pk]);
  const toConnect = mapToPrimary(
    current.filter(i => i[pk] && !initial.find(j => j[pk] === i[pk])),
    pk
  );
  const returnItem = {};
  if (toConnect.length) returnItem.connect = toConnect;
  if (toCreate.length) returnItem.create = toCreate;
  if (toDelete.length) returnItem.disconnect = toDelete;
  return returnItem;
}
exports.createConnectOrDisconnect = createConnectOrDisconnect;
